import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/consumption-types`, {
    params: {
      per_page: params.perPage,
      page: params.page,
      keyword: params.keyword,
      is_active: params.is_active,
    },
  });
};

export const DropdownList = () => {
  return APIService.get(`/v01/consumption-types/dropdown`);
};

export const Detail = (id) => {
  return APIService.get(`/v01/consumption-types/${id}`);
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/consumption-types`, body, config);
};

export const Put = (payload, config = {}) => {
  const { id } = payload;
  return APIService.put(`/v01/consumption-types/${id}`, { ...payload }, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/consumption-types/${id}`, config);
};

const ConsumptionTypeService = {
  List,
  DropdownList,
  Detail,
  Create,
  Put,
  Delt,
};

export default ConsumptionTypeService;
